module.exports = __webpack_public_path__ + "static/media/groceryStartShopping.8682aa52.svg";